module.exports = __webpack_public_path__ + "static/img/banner_cwpj.ba10d37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/banner/banner_cwpj.jpg
// module id = pEsE
// module chunks = 0